console.log('版本号：111158')
// 版本号：1800820 11.41
// import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from 'router'
import ElementUI from 'element-ui'
import 'common/styles/index.scss';
import axios from 'axios'
import store from './store/store'
import global from './global/global'
import cook from 'common/js/cook'
//我觉得这个拦截器没用
// import interceptor from 'common/js/interceptor.js';

// 全局参数配置
Vue.prototype.globalParams = global
Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.use(ElementUI)
let vm;
// axios 拦截器--超时判断
let timeOut = 0;
//添加一个响应拦截器，在这里最优先对返回的数据进行处理
axios.interceptors.response.use(function (res) {
  //下面这行对应上面的请求拦截器，感觉没卵用
  return res;
}, function (error) {
  if (error.response.status == 403 /*|| error.response.status == 499*/) {
    //仅在最后一次err才提示，利用了timeOut的作用域，缺点是引入了全局变量
    timeOut++;
    let x = timeOut
    setTimeout((x) => {
      if (x == timeOut) {
        vm.$notify({
          title: '失败',
          message: error.response.data.message,
          type: 'error'
        });
        vm.$store.commit('changeLoginTimeOutTo', true)//登录超时的全局变量
        timeOut = 0;
      }
    }, 500, x)
    //这里没有return就会在此中断响应，err数据为空,但err状态是拦不住的,
    // 所以console里会报res.response.message不存在的错，在所有catch里先判断response是否存在再执行（但loading=false的语句可以放在判断外面）
  } else {
    return Promise.reject(error);
  }
})

router.beforeEach((to, from, next) => {
  //NProgress.start();
  //新的登录方法，不好用的话就换成原来的
  let path = to.path.toLowerCase()
  let user = sessionStorage.getItem('usersPG') || sessionStorage.getItem('user');
  console.log('getCookie' + cook.getCookie('user'))
  //跳转促销员详情的时候，session会被清空
  if(path === '/salespersondetail' && cook.getCookie('user')){
    user = cook.getCookie('user')
  }
  //180704最新的登录方法
  if (user) {//有账户登录，就给他随便跳页。这里不太安全，如果知道了别人的网址也可以访问
    next()
  } else {//没有账户登录，就让登录
    //path会自动变成小写，而switch会区分大小写，需要注意
    switch (path) {
      case '/login'://普乐师登录页
      case '/loginpg'://宝洁登录页
        next();
        break;
      case '/salespersondatashow'://宝洁的专有页面都跳到他自己的登陆
        next({path: '/loginpg'})
        break;
      case '/jwtlogin':
        next();
        break;
      default:
        next({path: '/login'})
    }
  }
})

//添加 Bus  进行传值
window.eventBus = new Vue()
/* eslint-disable no-new */
vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js